import React, { useEffect, useRef, useState } from 'react';
import { layer, data, source } from 'azure-maps-control';
import AzureMapBase from 'components/maps/azure/AzureMapBase';
import { AZURE_MAPS_STYLES } from 'components/maps/azure/AzureMapsShared';


const AzureMapPoligon = ({ center, zone, height = "300px", zoom = 13 }) => {
    const dataSourceRef = useRef(null);
    const mapRef = useRef(null);
    const [mapReady, setMapReady] = useState(false);

    const ensureLayers = (map, dataSource) => {
        const polygonLayer = new layer.PolygonLayer(dataSource, null, {
            fillColor: AZURE_MAPS_STYLES.polygon.fillColor,
            fillOpacity: AZURE_MAPS_STYLES.polygon.fillOpacity
        });
        const lineLayer = new layer.LineLayer(dataSource, null, {
            color: AZURE_MAPS_STYLES.polygon.color,
            strokeWidth: AZURE_MAPS_STYLES.polygon.weight
        });
        map.layers.add([polygonLayer, lineLayer]);

    };

    const drawPolygon = (z) => {
        const map = mapRef.current;
        const dataSource = dataSourceRef.current;
        if (!map || !dataSource || !z || !z.polylines || z.polylines.length === 0) return;
        dataSource.clear();

        const coordinates = [z.polylines.map(p => [p.lng, p.lat])];

        if (coordinates[0].length > 0 &&
            (coordinates[0][0][0] !== coordinates[0][coordinates[0].length - 1][0] ||
                coordinates[0][0][1] !== coordinates[0][coordinates[0].length - 1][1])) {
            coordinates[0].push(coordinates[0][0]);
        }

        const polygon = new data.Feature(new data.Polygon(coordinates), { name: z.name });
        dataSource.add(polygon);

        // Fit bounds
        const bounds = data.BoundingBox.fromData(polygon);
        map.setCamera({ bounds: bounds, padding: 50 });
    };
    const onMapReady = (map) => {
        mapRef.current = map;

        const dataSource = new source.DataSource();
        map.sources.add(dataSource);
        dataSourceRef.current = dataSource;
        ensureLayers(map, dataSource);
        setMapReady(true);
    };

    useEffect(() => {
        if (mapReady && mapRef.current && dataSourceRef.current) {
            drawPolygon(zone);
        }
    }, [zone, mapReady]);

    return (
        <AzureMapBase
            center={center}
            zoom={zoom}
            height={height}
            onMapReady={onMapReady}
        />
    );
};

export default AzureMapPoligon;
